import { FC } from 'react';
import { RouteConfig } from '@/shared/lib';
import { AppSidebarLabel } from './AppSidebarLabel';
import { RouteNavIcon } from './RouteNavIcon';
import { SidebarFlyoutLink } from './SidebarFlyoutLink';

type Props = {
  route: RouteConfig;
  /** Переход по пункту — меню закрывается */
  onNavigate: () => void;
};

/**
 * Пункт группы в меню-подсказке свёрнутой группы и динамические пункты, подключённые к нему, —
 * сразу под ним, как и в развёрнутом списке.
 *
 * Хук динамических пунктов зовёт сам пункт: маршрут у него один на всё время жизни, поэтому и вызов
 * хука постоянный. Перебор пунктов в группе хуков не зовёт.
 */
export const SidebarFlyoutRouteLinks: FC<Props> = ({ route, onNavigate }) => {
  const dynamicItems = route.navbar?.dynamicItems?.() ?? [];

  return (
    <>
      <SidebarFlyoutLink
        item={{
          path: route.navbar?.path || route.path!,
          icon: <RouteNavIcon route={route} />,
          label: <AppSidebarLabel label={route.label} />,
        }}
        onNavigate={onNavigate}
      />
      {dynamicItems.map((item) => (
        <SidebarFlyoutLink key={item.key} item={item} onNavigate={onNavigate} />
      ))}
    </>
  );
};
